import { createSlice } from '@reduxjs/toolkit'
export const commonSlice = createSlice({
  name: 'common',
  initialState: {
    loading: false,
    formValidate: (values) => {
      let errors = {}
      for (const key in values) {
        if (values.hasOwnProperty(key)) {
          if (!values[key]) {
            errors[key] = `${key.charAt(0).toUpperCase() + key.slice(1)} is required.`
          } else if (key === 'email') {
            if (!/\S+@\S+\.\S+/.test(values.email)) {
              errors.email = 'Email address is invalid'
            }
          } else if (key === 'password') {
            if (values.password.length < 3) {
              errors.password = 'Password must be 3 or more characters'
            }
          } else if (key === 'url') {
            const pattern = new RegExp(
              '^([a-zA-Z]+:\\/\\/)?' + // protocol
              '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
              '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR IP (v4) address
              '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
              '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
              '(\\#[-a-z\\d_]*)?$', // fragment locator
              'i'
            )
            if (!pattern.test(values.url)) {
              errors.url = 'Url is invalid.'
            }
          } else if (key === 'phone') {
            const pattern = /^\d+$/;
            if (!pattern.test(values.phone)) {
              errors.phone = 'Phone number must contain only digits.';
            }
          } else if (key === 'title') {
            if (values.title.trim() === '') {
              errors.title = 'Title cannot be empty.';
            }
          }
        }
      }
      return errors
    },
    errors: { url: null, phone: null, email: null, title: null }
  },
  reducers: {
    setLoading(state, action) {
      state.loading = action.payload
    },
    setErrors(state, action) {
      state.errors = { ...state.errors, ...action.payload }
    },
    initializeErrors(state) {
      state.errors = { url: null, phone: null, email: null, title: null }
    },
  },
});

export const {
  setLoading,
  setErrors,
  initializeErrors
} = commonSlice.actions
export default commonSlice.reducer
